import React, { FC } from "react"
import { useSelector } from "react-redux"
import _ from "lodash"

import { ReservedFields, ReservedSections } from "@/onboarding/features/product/models/Product"
import CruiseLineOnly from "@/auth_descriptor/CruiseLineOnly"
import {
  countChangedFields,
  getProductRackCurrencyCode,
  getSectionChat,
  getSectionSettings,
  getSettings,
} from "@/onboarding/features/product/selectors"

import SectionHolder from "./shared/SectionHolder"
import CurrencyPicker from "./shared/CurrencyPicker"
import SettlementMethod from "./settlement/SettlementMethod"
import RatesDisplay from "./settlement/RatesDisplay"
import VehicleDisplay from "./settlement/VehicleDisplay"

// TODO(auth): We need to prevent this data from ever reaching the frontend instead of just
//  hiding it.
const Settlement: FC = () => {
  const { settlement_method } = useSelector(getSettings(ReservedFields.SETTLEMENT_METHOD))
  const proposedChangesCount = useSelector(countChangedFields(ReservedFields.SETTLEMENT_METHOD))
  const sectionChat = useSelector(getSectionChat(_.snakeCase("settlement")))
  const section = useSelector(getSectionSettings(ReservedSections.SETTLEMENT))
  const editable = section?.writeable === true
  const rackCurrencyCode = useSelector(getProductRackCurrencyCode)

  return (
    <SectionHolder
      title="Settlement"
      name={ReservedSections.SETTLEMENT}
      showLockedIcon={!settlement_method.writeable}
      chat={sectionChat}
      proposedChangesCount={proposedChangesCount}
    >
      <div className="d-flex flex-column gap-2">
        <CruiseLineOnly>
          <CurrencyPicker
            fieldName={ReservedFields.SELL_CURRENCY_CODE}
            label="Sell Rate Currency"
          />
        </CruiseLineOnly>
        <div className="d-flex justify-content-between gap-4">
          <SettlementMethod />
          <CruiseLineOnly>
            <RatesDisplay
              fieldName={ReservedFields.RACK_RATESHEET}
              rateLabel="Sell Rate"
              editable={editable}
              currencyCode={rackCurrencyCode}
            />
          </CruiseLineOnly>
        </div>
        <VehicleDisplay />
      </div>
    </SectionHolder>
  )
}
export default Settlement
